import { CSSProperties } from 'react';
import { Box, Center, Container, Divider, Flex, MantineSpacing, StyleProp } from '@mantine/core';
import { TFunction } from 'i18next';

import { Text } from 'components';

interface IStepper {
  activeStep: number;
  allowedReturnToStart?: boolean;
  numOfSteps: number;
  pt?: StyleProp<MantineSpacing>;
  steps?: any[];
  setActiveStep?: (val: number) => void;
  t: TFunction;
  titleKey: string;
  w?: StyleProp<CSSProperties['width']>;
  withDivider?: boolean;
}

const Stepper = ({
  activeStep,
  allowedReturnToStart = true,
  numOfSteps,
  pt,
  setActiveStep,
  steps,
  t,
  titleKey,
  w = '100%',
  withDivider = true,
}: IStepper) => {
  return (
    <>
      <Center mb={steps ? 'xl' : undefined} mt={{ base: 40, mb: 0 }}>
        <Flex direction={'row'} pt={pt} w={w}>
          {Array(numOfSteps).fill(null).map((_, index) => {
            const isActive = activeStep >= index;
            return (
              <Container key={`step-${index}`}>
                <Flex style={{ borderRadius: '100vh', margin: '0 auto' }} w='46' align='center' justify='center' bg={isActive ? '#62af45' : '#dde0e4'} onClick={() => {
                  if (setActiveStep && isActive) {
                    if (!allowedReturnToStart && index === 0) {
                      return;
                    }
                    setActiveStep(index);
                  }
                }}>
                  <Text
                    size={'xl'}
                    c={'white'}
                  >
                    {index + 1}
                  </Text>
                </Flex>
                <Text
                  size={'sm'}
                  c={isActive ? '#2F6F16' : '#474756'}
                  mt={10}
                  ta={'center'}
                >
                  {t(`${titleKey}.${index}.title`)}
                </Text>
              </Container>
            )
          }
          )}
        </Flex>
      </Center >
      {withDivider ? <Divider my={'md'} /> : undefined
      }
      {steps && steps[activeStep]}
    </>
  )
}

export default Stepper;